import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TableSignUserBase } from 'src/app/envelope/model/table-sign-user-base';
import { IDatePickerContainer, IDropdown, IToast, LayoutService, ToastService } from 'codex-lib';
import { Envelope } from '../model/envelope';
import { TranslateService } from '@ngx-translate/core';
import { IMyDateModel } from 'angular-mydatepicker';
import { DateTimeUtil } from 'src/app/util/date-time-util';
import { SegmentService } from 'src/app/modules/settings/services/segment.service';
import { AuthService } from 'src/app/services/auth.service';
import { SegmentAccessType } from 'src/app/enum/segment-access-type';
import { EnvelopeService } from '../services/envelope.service';
import { EnvelopeEdit } from '../model/envelope-edit';
import { ObjectUtil } from '../ObjectUtil';
import { UserTypes } from 'src/app/enum/user-types';

@Component({
  selector: 'app-envelope-details-edit',
  templateUrl: './envelope-details-edit.component.html',
  styleUrls: ['./envelope-details-edit.component.scss']
})
export class EnvelopeDetailsEditComponent implements OnInit, OnChanges {

  @Input() elementSelected: Envelope;
  @Output() modalCloseEmmiter = new EventEmitter();
  @Output() updateEnvelope = new EventEmitter();

  envelopeForm: FormGroup;
  tableSignUserBase: TableSignUserBase;
  expirationDropDown: IDropdown;
  rememberOptions: IDropdown;
  segmentDropdown: IDropdown;
  segmentSelected: any;
  reminderSelected: any;
  isRequiredUserSegment: boolean;
  rememberOptionsItens: any;
  envelopeDetail: Envelope;

  datePickerContainerModel: IMyDateModel;

  datePickerContainerOptions: IDatePickerContainer = {
    icon: null,
    AngularMyDpOptions: {
      firstDayOfWeek: 'su',
      dateRange: false,
      dateFormat: 'dd/mm/yyyy'
    },
    placeholder: 'codex.datePickerComponent.datePickerPlaceholder',
    model: {
      isRange: false
    }
  };

  envelope = { id: '', expiration: '', reminderFrequency: '', segment: '' };

  get id() {
    return this.envelopeForm.get('id');
  }
  get expiration() {
    return this.envelopeForm.get('expiration');
  }
  get reminderFrequency() {
    return this.envelopeForm.get('reminderFrequency');
  }
  get segment() {
    return this.envelopeForm.get('segment');
  }

  constructor(private modalService: NgbModal
    , private translateService: TranslateService
    , private segmentService: SegmentService
    , private authService: AuthService
    , private envelopeService: EnvelopeService
    , private layoutService: LayoutService
    , private toastService: ToastService
  ) { }

  ngOnInit() {

    this.rememberOptions = {
      displayText: 'value',
      placeholder: this.translateService.instant('envelope.signatory.reminderFrequency.placeholder'),
      items: this.reminderFrequecyList(),
      showSearch: false
    };

    if (!(this.envelope.reminderFrequency) || ObjectUtil.isEmpty(this.envelope.reminderFrequency)) {
      this.envelope.reminderFrequency = this.rememberOptions.items[0];
    }

    this.segmentDropdown = {
      displayText: 'value',
      placeholder: this.translateService.instant('envelope.signatory.reminderFrequency.placeholder'),
      items: [],
      showSearch: true
    };

    this.userSegment();

    this.envelopeForm = new FormGroup({
      id: new FormControl(this.envelope.id, Validators.required),
      expiration: new FormControl(this.envelope.expiration, []),
      reminderFrequency: new FormControl(this.envelope.reminderFrequency, []),
      segment: new FormControl(this.envelope.segment, [
        Validators.required
      ]),
    });
  }

  reminderFrequecyList() {
    return [
      { id: 1, value: this.translateService.instant('envelope.signatory.reminderFrequency.doNotSend') },
      { id: 2, value: this.translateService.instant('envelope.signatory.reminderFrequency.EveryDay') },
      { id: 3, value: this.translateService.instant('envelope.signatory.reminderFrequency.EveryCountDay', { dayCount: 2 }) },
      { id: 4, value: this.translateService.instant('envelope.signatory.reminderFrequency.EveryCountDay', { dayCount: 4 }) },
      { id: 5, value: this.translateService.instant('envelope.signatory.reminderFrequency.EveryCountDay', { dayCount: 7 }) }
    ];

  }

  onExpirationSelectItem(value: IMyDateModel) {
    this.envelopeForm.get('expiration').setValue(value);
    this.expiration.setValue(value);
    this.datePickerContainerModel = value;

    if (value != null && value !== undefined
      && value.singleDate != null && value.singleDate !== undefined) {
      if (value.singleDate.epoc < DateTimeUtil.getCurrentTimestamp()) {

        // Variavel que define o erro na validação do form do datepicker.
        this.envelopeForm.get('expiration').setErrors({ dateInvalid: true });
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.elementSelected && changes.elementSelected.currentValue) {
      setTimeout(() => {
        this.envelopeDetail = changes.elementSelected.currentValue;
        this.id.setValue(this.envelopeDetail.id);

        if (this.envelopeDetail.segment != null) {
          this.segmentSelected = this.segmentDropdown.items.find(x => x.id == this.envelopeDetail.segment.id);
          this.segment.setValue(this.envelopeDetail.segment);
        }

        if (this.envelopeDetail.reminderFrequency != null) {
          this.reminderSelected = this.reminderFrequecyList().find(x => x.id == this.envelopeDetail.reminderFrequency);
          this.reminderFrequency.setValue(this.reminderSelected);
        }

        this.setDateExpirationEnvelope(this.envelopeDetail.expiration);
      });
    }
  }

  setDateExpirationEnvelope(dateExpiration) {
    if (dateExpiration != null) {
      const date = new Date(dateExpiration);
      this.datePickerContainerModel = {
        isRange: false,
        singleDate: {
          date: {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
          },
          formatted: date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear(),
          jsDate: date
        }
      };
    }
  }

  onSegmentSelectItem(value) {
    this.envelopeForm.get('segment').setValue(value);
  }

  onReminderSelectItem(value) {
    this.envelopeForm.get('reminderFrequency').setValue(value);
  }

  private userSegment() {

    this.segmentService.getSegments(false).subscribe(x => {
      const items = x.map(y => ({ id: y.id, value: y.name }));
      this.segmentDropdown = {
        items,
        displayText: 'value',
        clearSelectionItem: true,
        placeholder: items.length > 0
          ? this.translateService.instant('selectAnItem')
          : this.translateService.instant('settings.segment.modalAdd.noSegmentFounded'),
        showSearch: false
      };
      this.authService.authModel.subscribe(authModel => {
        this.isRequiredUserSegment = authModel.signUser.segmentAccessType === SegmentAccessType.FULL_ACCESS
          || authModel.signUser.type === UserTypes.Admin ? false : true;

        if (!this.isRequiredUserSegment) {
          this.envelopeForm.get('segment').clearValidators();
          this.envelopeForm.get('segment').updateValueAndValidity();
        }
        if (this.segmentDropdown !== undefined && this.segmentDropdown.items !== undefined && this.envelopeForm.get('segment').value != null) {
          this.segmentSelected = this.segmentDropdown.items.find(x => x.id == this.envelopeForm.get('segment').value.id);
          this.onSegmentSelectItem(this.segmentSelected);
        }
      });
    });
  }

  editEnvelope() {
    if (this.envelopeForm.valid) {
      const envelopeEdit: EnvelopeEdit = new EnvelopeEdit();
      envelopeEdit.id = this.id.value;

      if (this.expiration.value != null) {
        envelopeEdit.expiration = this.expiration.value.singleDate.jsDate;
      }

      if (this.reminderFrequency.value.id > 0) {
        envelopeEdit.reminderFrequency = this.reminderFrequency.value.id;
      }

      if (this.segment.value != null) {
        envelopeEdit.segmentId = this.segment.value.id;
      }

      this.envelopeService
        .update(envelopeEdit.id, envelopeEdit)
        .subscribe(
          response => {
            this.layoutService.toggleLoading(false);
            const toast: IToast = {
              text: this.translateService.instant('envelope.edit-modal.toast.editSucess'),
              autoHide: true,
              type: 'success'
            };
            this.toastService.createNewToast(toast);
            this.updateEnvelope.emit();
            this.modalService.dismissAll();
          },
          error => this.layoutService.toggleLoading(false)
        );
    }
  }

  modalClose() {
    this.modalCloseEmmiter.emit(true);
    this.modalService.dismissAll();
  }

}
